// Barrel export for seller services

// Auth exports
export * from './seller-auth';

// Profile exports
export * from './seller-profile';

// Dashboard exports
export * from './seller-dashboard';

// Orders exports
export * from './seller-orders';

// Order actions exports
export * from './seller-order-actions';

// Products exports
export * from './seller-products';

// Store exports
export * from './seller-store';

// Application exports
export * from './seller-application';

// Discount exports
export * from './discount/discount-offers';
export * from './discount/discount-time';
export * from './discount/discount-defaults';

// Helper exports (internal use)
export * from './seller-helpers';

// Re-export all functions under sellerService namespace for backward compatibility
import * as auth from './seller-auth';
import * as profile from './seller-profile';
import * as dashboard from './seller-dashboard';
import * as orders from './seller-orders';
import * as orderActions from './seller-order-actions';
import * as products from './seller-products';
import * as store from './seller-store';
import * as application from './seller-application';
import * as discountOffers from './discount/discount-offers';
import * as discountTime from './discount/discount-time';

export const sellerService = {
  // Auth
  getSellerRestaurantId: auth.getSellerRestaurantId,
  checkSellerAuth: auth.checkSellerAuth,
  validateSellerAccess: auth.validateSellerAccess,
  
  // Profile
  createSellerProfile: profile.createSellerProfile,
  getSellerProfile: profile.getSellerProfile,
  updateSellerProfile: profile.updateSellerProfile,
  updateSellerStatus: profile.updateSellerStatus,
  getAllSellers: profile.getAllSellers,
  deleteSellerProfile: profile.deleteSellerProfile,
  // checkNicknameAvailability 제거됨 (nickname 필드가 DB에서 삭제됨)
  
  // Dashboard
  getDashboardData: dashboard.getDashboardData,
  getOrderCounts: dashboard.getOrderCounts,
  toggleBusinessStatus: dashboard.toggleBusinessStatus,
  
  // Orders
  getAllOrdersForRestaurant: orders.getAllOrdersForRestaurant,
  getOrdersByStatus: orders.getOrdersByStatus,
  getMultipleStatusOrders: orders.getMultipleStatusOrders,
  getOrderDetail: orders.getOrderDetail,
  getOrderByNumber: orders.getOrderByNumber,
  searchOrdersByNumber: orders.searchOrdersByNumber,
  
  // Order Actions
  updateOrderStatus: orderActions.updateOrderStatus,
  acceptOrder: orderActions.acceptOrder,
  rejectOrder: orderActions.rejectOrder,
  markOrderReady: orderActions.markOrderReady,
  completeOrder: orderActions.completeOrder,
  markOrderNoShow: orderActions.markOrderNoShow,
  cancelOrder: orderActions.cancelOrder,
  cancelDeadlineOrdersByProducts: orderActions.cancelDeadlineOrdersByProducts,
  
  // Products
  getSellerProducts: products.getSellerProducts,
  setDeadlineDiscountProducts: products.setDeadlineDiscountProducts,
  setReservationDiscountProducts: products.setReservationDiscountProducts,
  createProducts: products.createProducts,
  updateProduct: products.updateProduct,
  deleteProduct: products.deleteProduct,
  getDeadlineTemplateProducts: products.getDeadlineTemplateProducts,
  upsertDeadlineTemplateProducts: products.upsertDeadlineTemplateProducts,
  deleteDeadlineTemplateProduct: products.deleteDeadlineTemplateProduct,
  syncDeadlineTemplateImages: products.syncDeadlineTemplateImages,
  
  // Store
  getStoreInfo: store.getStoreInfo,
  updateStoreInfo: store.updateStoreInfo,
  getOperatingHours: store.getOperatingHours,
  updateOperatingHours: store.updateOperatingHours,
  getRestaurantStatus: store.getRestaurantStatus,
  getDeadlineOrderWindow: store.getDeadlineOrderWindow,
  toggleRestaurantStatus: store.toggleRestaurantStatus,
  getReservationDiscountStatus: store.getReservationDiscountStatus,
  toggleReservationDiscount: store.toggleReservationDiscount,
  getDeadlineDiscountToggle: store.getDeadlineDiscountToggle,
  updateDeadlineDiscountToggle: store.updateDeadlineDiscountToggle,
  
  // Application
  getApplicationStatus: application.getApplicationStatus,
  getApplicationDetails: application.getApplicationDetails,
  
  // Discount Offers
  getProductOffers: discountOffers.getProductOffers,
  upsertProductOffer: discountOffers.upsertProductOffer,
  removeProductOffer: discountOffers.removeProductOffer,
  batchUpsertProductOffers: discountOffers.batchUpsertProductOffers,
  
  // Discount Time
  subtractMinutes: discountTime.subtractMinutes,
  addMinutes: discountTime.addMinutes,
  calculateValidFrom: discountTime.calculateValidFrom,
  generateTimeOptions: discountTime.generateTimeOptions,
};
